import { connect } from 'react-redux'
import { Samples } from '../components/Samples'

const SamplesContainer = connect()(Samples)

export default SamplesContainer